
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import { createAdmin } from "../../middleware/backend_hepler";
import { toast, ToastContainer } from "react-toastify";
import { validationRules } from "../../utils/validationRules";
import "react-toastify/dist/ReactToastify.css";
import ButtonLoader from "../../components/ButtonLoader";
import logo from "../../assets/logo1.png";

const CustomerSignupForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const methods = useForm({ mode: "onChange", reValidateMode: "onChange" });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const password = watch("password", "");
  const dob = watch("dob");

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setValue("age", age >= 0 ? age : "");
    }
  }, [dob, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          formDataToSend.append(key, data[key]);
        }
      });
      const role = data.role;

      if (role === "agent") {
        formDataToSend.append("status", "Inprogress");
      } else if (role === "customer") {
        formDataToSend.append("status", "Active");
      }

      await createAdmin(formDataToSend);
      setLoading(false);
      toast.success("Signup successful!");
      navigate("/login");
    } catch (error) {
      setLoading(false);
      if (
        error.response?.data?.error.includes("Duplicate entry") &&
        error.response.data.error.includes("mobile")
      ) {
        toast.error("Mobile number already exists.");
      } else if (error.response?.data?.error.includes("Duplicate entry")) {
        toast.error("Email already exists.");
      } else {
        console.error("Signup error:", error);
        toast.error("Signup failed. Please try again.");
      }
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <div className="signup-box">
          <img src={logo} alt="Logo" className="logo" />
          <h2>Signup!</h2>
          <p>Signup to continue to Right Lender now.</p>
          <FormProvider {...methods}>
            <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
              <div className={`form-group ${errors.name ? "error" : ""}`}>
                <label htmlFor="name">Name<span className="required-asterisk">*</span></label>
                <input
                  id="name"
                  name="name"
                  className="signup-field"
                  placeholder="Enter name"
                  {...register("name", { required: "Name is required" })}
                />
                {errors.name && (
                  <p className="error-message">{errors.name.message}</p>
                )}
              </div>

              <div className={`form-group ${errors.dob ? "error" : ""}`}>
                <label htmlFor="dob">Date of Birth<span className="required-asterisk">*</span></label>
                <input
                  type="date"
                  id="dob"
                  className="signup-field"
                  name="dob"
                  {...register("dob", { required: "DOB is required" })}
                />
                {errors.dob && (
                  <p className="error-message">{errors.dob.message}</p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="age">Age</label>
                <input
                  id="age"
                  name="age"
                  type="number"
                  className="signup-field"
                  readOnly
                  {...register("age")}
                />
              </div>

              <div className={`form-group ${errors.mobile ? "error" : ""}`}>
                <label htmlFor="mobile">Mobile<span className="required-asterisk">*</span></label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  className="signup-field"
                  placeholder="Enter mobile number"
                  {...register("mobile", validationRules.mobile)}
                />
                {errors.mobile && (
                  <p className="error-message">{errors.mobile.message}</p>
                )}
              </div>

              <div className={`form-group ${errors.email ? "error" : ""}`}>
                <label htmlFor="email">Email<span className="required-asterisk">*</span></label>
                <input
                  className="signup-field"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter email"
                  {...register("email", validationRules.email)}
                />
                {errors.email && (
                  <p className="error-message">{errors.email.message}</p>
                )}
              </div>

              <div className={`form-group ${errors.role ? "error" : ""}`}>
                <label htmlFor="role">Role<span className="required-asterisk">*</span></label>
                <select
                  id="role"
                  className="signup-field"
                  {...register("role", { required: "Role is required" })}
                >
                  <option value="">Select</option>
                  <option value="agent">Agent</option>
                  <option value="customer">Customer</option>
                </select>
                {errors.role && (
                  <p className="error-message">{errors.role.message}</p>
                )}
              </div>

              <div className={`form-group ${errors.password ? "error" : ""}`}>
                <label htmlFor="password">Password<span className="required-asterisk">*</span></label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="signup-field"
                  placeholder="Enter password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Minimum 8 characters required",
                    },
                  })}
                />
                {errors.password && (
                  <p className="error-message">{errors.password.message}</p>
                )}
              </div>

              <div
                className={`form-group ${errors.confirm_password ? "error" : ""
                  }`}
              >
                <label htmlFor="confirm_password">Confirm Password<span className="required-asterisk">*</span></label>
                <input
                  type="password"
                  id="confirm_password"
                  name="confirm_password"
                  className="signup-field"
                  placeholder="Confirm password"
                  {...register("confirm_password", {
                    required: "Confirm Password is required",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  })}
                />
                {errors.confirm_password && (
                  <p className="error-message">
                    {errors.confirm_password.message}
                  </p>
                )}
              </div>

              <div className="text-center">
                {!loading ? (
                  <button type="submit">Signup</button>
                ) : (
                  <ButtonLoader />
                )}
                <p className="signup-text">
                  Already have an account?{" "}
                  <Link to="/login" className="signup-link">
                    Login.
                  </Link>
                </p>
              </div>
            </form>
          </FormProvider>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default CustomerSignupForm;

